import Block, { BlockProps } from "./Block";
import DefaultFields from "./Block/DefaultFields";
import { createEmptySources } from "./Block/hooks";

const PowerBlock = ({
  sources = createEmptySources(),
  headerInjection,
  banner,
  ...props
}: Omit<BlockProps, "DefaultFields"> & {
  headerInjection?: React.ReactNode | ((isScrolled: boolean) => React.ReactNode);
  banner?: React.ReactNode;
}) => (
  <div className="h-full">
    {props.type && (
      <Block
        DefaultFields={DefaultFields}
        type={props.type}
        {...props}
        sources={sources}
        readonly={props.readonly}
        headerInjection={headerInjection}
        banner={banner}
      />
    )}
  </div>
);

export default PowerBlock;
